<template>
  <div>
    <dialogos-app :dialogos="dialogos"></dialogos-app>
    <v-layout wrap justify-center align-center class="vh40">
      <v-flex xs12 md6 text-xs-center>
        <img class="animated fadeIn dura-1" src="../../assets/Modulo 2/diapositiva-2.png" alt="">
      </v-flex>
      <v-flex xs12 md6>
        <ul class="texto1 lista1 pl-4 animated fadeIn dura-1">
          <li class="animated fadeIn dura-2"><span>Society of Petroleum Engineers</span></li>
          <li class="animated fadeIn dura-3"><span>Petroleum Resources Management System</span></li>
        </ul>
      </v-flex>
    </v-layout>
    
    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Modulo 2/AUDIO 02'
    ]"></audio-player> 
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogos: [
        "La clasificación de las reservas y los recursos se rige por diferentes normas, las cuales vimos previamente en el módulo 1. En éste módulo profundizaremos en la clasificación según SPE - PRMS." 
      ]
    }
  },
  created() {
    this.$store.commit('nextShow', true)
  }
}
</script>
<style lang="scss" scoped>
</style>
